import React from "react";
import { styled } from "@linaria/react";
import testimonialImageSrc from "./assets/j-miller-min.png";
import companyLogoSrc from "./assets/middlebury-logo.png";
import { FlexColumn, FlexRow } from "components/rui/layout";
import { TextContainer } from "components/rhombus-UI/theme/containers";

const Card = styled(FlexRow)`
  display: flex;
  width: 100%;
  max-width: 1320px;
  height: 513px;
  padding: 28px;
  gap: 28px;
  flex-shrink: 0;
  background-color: ${(props) => props.color};
  border-radius: 1rem;
  overflow: hidden;
  align-items: center;
  .card-image {
    height: 100%;
    object-fit: contain;
    max-height: 513px;
  }
  q {
    color: var(--primary-bg);
    font-size: 28px;
    font-weight: 500;
    line-height: 1.5;
    font-family: var(--headerFontFamily);
  }
  @media (max-width: 1150px) {
    q {
      font-size: 24px;
    }
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    width: 100%;
    height: unset;
    align-items: flex-start;
    .card-image {
      object-fit: cover;
      width: 100%;
      border-radius: 1rem;
      max-height: 440px;
    }
  }
  @media (max-width: 600px) {
    .author-row {
      flex-direction: column;
      align-items: flex-start !important;
      justify-content: flex-start;
      img {
        object-position: "left";
      }
    }
  }
`;

const HighlightText = styled(FlexColumn)`
  border-left: 1px solid var(--neutral-900);
  padding-left: 14px;
  gap: 7px;
  h3 {
    font-size: 20px;
  }
  p {
    text-transform: uppercase;
    line-height: 1;
    font-size: 14px;
  }
  @media (max-width: 600px) {
    p {
      font-size: 12px;
    }
  }
`;

const TestimonialCard = ({
  cardColor = "var(--white)",
  stat1 = { value: "70%", label: "shorter investigation time" },
  stat2 = { value: "80%", label: "decrease in system outages" },
  quote = `With Rhombus, we've reduced the time it takes to investigate incidents by 70%. What used to take hours of reviewing footage now only takes minutes.`,
  author = {
    name: "Jeremy Miller",
    title: "Director of Technology and Communications",
    company: "Middlebury Community Schools",
  },
  testimonialImage = testimonialImageSrc,
  companyLogo = { src: companyLogoSrc, height: 82, width: 82 },
}) => {
  return (
    <Card color={cardColor}>
      <img src={testimonialImage} className="card-image" alt={author.company} />
      <FlexColumn
        style={{
          gap: "2.5rem",
          justifyContent: "center",
        }}
      >
        <FlexRow style={{ gap: "48px" }}>
          <HighlightText>
            <h3>{stat1.value}</h3>
            <p>{stat1.label}</p>
          </HighlightText>
          <HighlightText>
            <h3>{stat2.value}</h3>
            <p>{stat2.label}</p>
          </HighlightText>
        </FlexRow>
        <q>{quote}</q>
        <FlexRow
          style={{ alignItems: "center", gap: "20px" }}
          className="author-row"
        >
          <img
            src={companyLogo.src}
            width={companyLogo.width}
            height={companyLogo.height}
            alt={author.company}
          />
          <TextContainer>
            <span>
              <b>{author.name},</b> {author.title}
            </span>
            <b>{author.company}</b>
          </TextContainer>
        </FlexRow>
      </FlexColumn>
    </Card>
  );
};

export default TestimonialCard;
